<template>
  <b-modal
    title="ALTERAR SENHA"
    id="change_password"
    no-close-on-backdrop
    hide-footer
    @show="evOnShow"
    @shown="evOnShown"
  >
    <b-overlay :show="loading" opacity="0.99">
      <form @submit.prevent="evOnSubmit">
        <div class="row">
          <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            <LabelRequiredField label="Senha" />
            <b-input-password v-model="password" ref="autofocus" />
          </div>
          <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            <LabelRequiredField label="Confirmação de senha" />
            <b-input-password v-model="confirm_password" />
          </div>
          <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            <WarningRequiredFields v-if="permission('edit', 'user')" />
            <ErrorsMessages :errors="errors" />
          </div>
          <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0">
            <v-btn class="btn-cancel" @click="$bvModal.hide('change_password')">
              CANCELAR
            </v-btn>
          </div>
          <div
            class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 text-right pt-0"
          >
            <v-btn type="submit" class="btn-save ml-2">
              <i class="fas fa-save mr-2 text-twenty"></i>
              SALVAR
            </v-btn>
          </div>
        </div>
      </form>
    </b-overlay>
  </b-modal>
</template>

<script>
import LabelRequiredField from "../Components/LabelRequiredField";
import WarningRequiredFields from "../Components/WarningRequiredFields";
import ErrorsMessages from "../Components/ErrorsMessages";

import permission from "../../lib/permission";
import toast from "../../lib/ToastNotification";
import api from "../../services/api";
import BInputPassword from "../Components/BInputPassword.vue";

export default {
  name: "ChangePassword",

  components: {
    LabelRequiredField,
    WarningRequiredFields,
    ErrorsMessages,
    BInputPassword,
  },

  props: {
    id: [Number, String],
  },

  data() {
    return {
      errors: [],
      loading: false,

      password: "",
      confirm_password: "",
    };
  },

  methods: {
    permission,

    async evOnShow() {
      this.errors = [];
      this.loading = false;

      this.password = "";
      this.confirm_password = "";

      this.show_password = false;
      this.show_confirm_password = false;
    },

    async evOnShown() {
      this.$refs.autofocus.focus();
    },

    async evOnSubmit() {
      try {
        this.loading = true;

        let { id, password, confirm_password } = this;

        const params = {
          id,
          password,
          confirm_password,
        };

        const response = await api.patch(
          "/rest-home/customer/password",
          params
        );

        const { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.$bvModal.hide("change_password");
          this.password = "";
          this.confirm_password = "";
          toast(message, "success");
          this.errors = [];
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>